import moment from 'moment';
//TODO: Cleanup/remove - seems to be an unused file refer to reprocessPaymentFillRequest on mailorderRefill file...
(() => {
  class ReprocessChargeRefillController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, Orders, Users, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Users,
        $state,
        ngDialog,
        prescription: $scope.ngDialogData.prescription,
        visit: $scope.ngDialogData.visit,
        mail_order_id: $scope.ngDialogData.mail_order_id,
        refillDetails: $scope.ngDialogData.RefillDetails,
        charging: false,
        fillCharged: Orders.TOTALFILLS,
        fillSent: Orders.TOTALFILLS,
        isRecurring: false,
      }); // if(this.prescription.mail_order.recurring_discount_amount && this.prescription.mail_order.recurring_discount_amount > 0){
      //   this.isRecurring = true;
      //   this.refillDetails.amountCharged = this.refillDetails.amountCharged - (this.prescription.mail_order.recurring_discount_amount * this.refillDetails.num_to_charge);
      // }

      if (
        this.refillDetails.medication_amount_before_discount &&
        this.prescription.mail_order.recurring_discount_amount &&
        this.prescription.mail_order.recurring_discount_amount > 0
      ) {
        this.isRecurring = true;
        this.refillDetails.amountCharged =
          this.refillDetails.medication_amount_before_discount -
          this.prescription.mail_order.recurring_discount_amount * this.refillDetails.num_to_charge;
      }

      if (
        !this.refillDetails.medication_amount_before_discount &&
        this.prescription.mail_order.recurring_discount_amount &&
        this.prescription.mail_order.recurring_discount_amount > 0
      ) {
        this.isRecurring = true;
        this.refillDetails.amountCharged =
          this.refillDetails.amountCharged -
          this.prescription.mail_order.recurring_discount_amount * this.refillDetails.num_to_charge;
      } // WE WILL KEEP "refillDetails.fill_date" AS DATE WITHOUT TIME
      // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE
      // this.refillDetails.fill_date = moment(this.refillDetails.fill_date).format('MM-DD-YYYY');

      var fill_date = this.refillDetails.fill_date.split('-');
      this.refillDetails.fill_date = new Date(
        parseInt(fill_date[0]),
        parseInt(fill_date[1]) - 1,
        parseInt(fill_date[2]),
      );
      this.refillDetails.fill_date.setHours(0, 0, 0, 0);
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    medicationCharge() {
      var this2 = this;
      var mail_order_id = this.mail_order_id;
      var today = moment().format('YYYY-MM-DD');

      if (isNaN(this.refillDetails.amountCharged)) {
        this.refillDetails.amountCharged = this.refillDetails.amountCharged.replace('£', '');
      }

      this.chargeData = {
        amount: this.refillDetails.amountCharged,
      }; // WE WILL KEEP "refillDetails.fill_date" AS DATE WITHOUT TIME
      // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE

      this.refillDetails.fill_date.setHours(0, 0, 0, 0);
      this.refill_Date = moment(this.refillDetails.fill_date).format('YYYY-MM-DD');
      var fillDetail = {
        fill_date: this.refill_Date,
      };
      this.processing = true;

      if (today <= this2.refill_Date) {
        this2.Orders.updateMailorderFill(mail_order_id, this2.refillDetails.id, fillDetail)
          .then(({ data }) => {
            if (today === this2.refill_Date) {
              this.Orders.mailorderFillPayment(mail_order_id, this2.refillDetails.id, this.chargeData)
                .then(({ data }) => {
                  this2.Orders.mailorderFillProcess(mail_order_id, this2.refillDetails.id)
                    .then(({ data }) => {
                      this2.toastr.success('Payment and Fill Request were sent successfully.');
                      var parameters = {
                        dollar_sign: false,
                        pill_sign: true,
                        new_prescription: false,
                        show_prescriber: false,
                        include_icon_url: false,
                      };
                      this2.Orders.callSlackToNotify(this2.prescription, parameters, this2.visit);
                      this2.processing = false;
                      this2.$scope.closeThisDialog(true);
                    })
                    .catch(err => {
                      this2.toastr.success('Payment was successful.');
                      this2.toastr.error('Error sending fill request: ' + err.data.message.summary);
                      this2.processing = false;
                      this2.$scope.closeThisDialog(true);
                    });
                })
                .catch(err => {
                  if (err.status === 400 || err.status === 409) {
                    this2.toastr.error('Error processing payment: ' + err.data.message.summary);
                  } else {
                    this2.toastr.error('Error processing payment: ' + err.status + ' - ' + err.message);
                  }

                  var parameters = {
                    dollar_sign: true,
                    pill_sign: false,
                    new_prescription: false,
                    show_prescriber: false,
                    include_icon_url: false,
                  };
                  this2.Orders.callSlackToNotify(this2.prescription, parameters, this2.visit);
                  this2.processing = false;
                  this2.$scope.closeThisDialog(false);
                });
            } else {
              this2.toastr.success('Payment and Fill Request will be processed on ' + this2.refill_Date);
              this2.processing = false;
              this2.$scope.closeThisDialog(true);
            }
          })
          .catch(err => {
            this2.toastr.error('Error updating the mailorder fills: ' + err.data.message.summary);
            this2.processing = false;
            this2.$scope.closeThisDialog(false);
          });
      } else {
        this2.toastr.error('please check the entered date');
        this2.processing = false;
        this2.$scope.closeThisDialog(false);
      }
    }
  }

  ReprocessChargeRefillController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    'toastr',
    'Orders',
    'Users',
    '$state',
    'ngDialog',
  ];
  angular.module('pims').controller('ReprocessChargeRefillController', ReprocessChargeRefillController);
})();
